var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-price-other"
  }, [_c('div', {
    staticClass: "safety-warning"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("安全提示")]), _c('p', {
    staticClass: "txt-p"
  }, [!_vm.isFxb ? _c('span', [_vm._v("云客赞")]) : _vm._e(), _vm.isFxb ? _c('span', [_vm._v("我们")]) : _vm._e(), _vm._v("提醒您注意人身安全，参加有一定危险性的室内或户外活动（如漂流、蹦床、攀岩、蹦床、游乐园、水上运动等）或进行餐饮/入住前，请务必仔细阅读\n        "), _c('i', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goSafetyManualPage.apply(null, arguments);
      }
    }
  }, [_vm.isFxb ? _c('span', [_vm._v("《安全手册》")]) : _c('span', [_vm._v("《云客赞安全手册》")])]), _vm._v("。\n      ")])]), _c('div', {
    staticClass: "price-intro",
    class: {
      'folded-state': _vm.priceFolded
    }
  }, [_vm.priceFolded ? [_c('p', {
    staticClass: "txt-p",
    on: {
      "~click": function click($event) {
        $event.stopPropagation();
        return _vm.expandPriceInfo.apply(null, arguments);
      }
    }
  }, [_vm._v("点击查看价格说明")])] : [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("价格说明")]), _vm._m(0), _vm._m(1)]], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "txt-p"
  }, [_c('i', [_vm._v("划线价格：")]), _vm._v("指商品或服务的挂牌价、门市价、指导价或该商品或服务的曾经展示过的销售价等，并非法定意义上的原价，仅供参考。")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "txt-p margin-top"
  }, [_c('i', [_vm._v("未划线价格：")]), _vm._v("指商品或服务的实时标价，不因表述的差异改变性质。具体成交价格根据商品或服务参加活动，或会员使用现金券、积分等发生变化，最终以订单结算页价格为准。")]);
}];
export { render, staticRenderFns };